<template>
  <div class="inquiry-container">
    <SeedJung_Header></SeedJung_Header>
    <div class="inquiry-content">
      <h2>여러분의 목소리에 귀 기울입니다</h2>
      <p class="intro-text">
        상담에 대한 궁금증, 제안, 또는 어떤 이야기든 <span class="mobile-break"></span>편하게 남겨주세요.
      </p>
      <form @submit.prevent="submitInquiry">
        <div class="form-group">
          <input type="text" v-model="title" placeholder="제목" required>
        </div>
        <div class="form-group">
          <input type="email" v-model="email" placeholder="이메일 주소" required>
        </div>
        <div class="form-group">
          <textarea v-model="content" placeholder="문의 내용" required></textarea>
        </div>
        <button type="submit" class="submit-btn" :disabled="isLoading">
          {{ isLoading ? '처리중...' : '문의하기' }}
        </button>
      </form>
      <!-- <p class="subtext">
        소중한 의견은 저희에게 큰 힘이 됩니다. <br>
        함께 더 나은 서비스를 만들어가요!
      </p> -->
      <p class="email-info">
        문의하신 내용은 <span class="email">seed@seedjung.co.kr</span>로 전달되며, <br />이메일을 통해 답변 드리겠습니다.
      </p>


    </div>
  </div>
</template>

<script>
import SeedJung_Header from './SeedJung_Header.vue'
import axios from 'axios'  // 추가
export default {
  name: 'SeedJung_Inquiry',
  components: {
    SeedJung_Header
  },
  data() {
    return {
      title: '',
      email: '',
      content: '',
      isLoading: false
    }
  },
  methods: {
    async submitInquiry() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        const response = await axios.post('/api/send-inquiry', {
          title: this.title,
          email: this.email,
          content: this.content
        });
        alert(response.data.message);
        this.title = '';
        this.email = '';
        this.content = '';
      } catch (error) {
        // HTTP 429 상태 코드(Rate Limit Exceeded) 체크
        if (error.response && error.response.status === 429) {
          alert(error.response.data.message);  // "너무 많은 문의를 보내셨습니다. 1시간 후에 다시 시도해주세요."
        } else {
          alert('문의 접수 실패. seed@seedjung.co.kr로 이메일 문의 부탁드립니다.');
        }
      } finally {
        this.isLoading = false;
      }
    }
    // submitInquiry() {
    //   console.log('제목:', this.title);
    //   console.log('이메일:', this.email);
    //   console.log('내용:', this.content);
    //   alert('문의가 접수되었습니다. 소중한 의견 감사합니다.');
    //   this.title = '';
    //   this.email = '';
    //   this.content = '';
    // }
  }
}
</script>

<style scoped>
.mobile-break {
  display: none;
}
.inquiry-container {
  text-align: center;
  padding: 1rem;
  font-family: 'Arial', sans-serif;
}

.inquiry-content {
  max-width: 800px;
  margin: 0 auto;
  margin-top: 170px;
  background-color: #f8f8f8;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
}

.intro-text, .subtext {
  color: #555;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

input, textarea {
  width: 100%;
  padding: 0.7rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

textarea {
  height: 150px;
  resize: vertical;
}

.submit-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 1.5rem;
}

.submit-btn:hover {
  background-color: #0056b3;
}

.subtext {
  font-style: italic;
  color: #777;
  font-size: 0.9em;
}

.email-info {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #555;
}

.email {
  font-weight: bold;
  color: #007bff;
}

@media screen and (max-width: 600px) {
  .inquiry-content {
    margin-top: 100px;
    padding: 1.5rem;
  }

  h2 {
    font-size: 1.9rem;
  }

  .intro-text, .subtext, .email-info {
    font-size: 1.2rem;
  }

  input, textarea, .submit-btn {
    font-size: 1.2rem;
  }
  
  .subtext {
    font-size: 1.2rem;
  }

  .mobile-break {
    display: block;
  }
}
</style>